module.exports = __webpack_public_path__ + "img/3.5d957fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/fair-uni/3.png
// module id = 1510
// module chunks = 1